import React from "react";
import cx from "classnames";
import Icon from "components/utils/icon";
import { ID } from "utils/constants";
import layout from "utils/layout";
import "./index.scss";

const APPLICATIONS = [ID.CHAT, ID.NOTES, "close"];

const Control = ({ current, toggleApplication, toggleHideMessage }) => {
  if (!layout.control) return null;

  const handleClickIcon = (application, active) => {
    if (application === "close") return toggleHideMessage();
    if (!active) toggleApplication(application);
  };

  return (
    <div className="application-control">
      {APPLICATIONS.map((application, index) => {
        const active = current === application;

        return (
          <div
            className={cx("application-icon", { inactive: !active })}
            // onClick={() => (active ? null : toggleApplication(application))}
            onClick={() => handleClickIcon(application, active)}
            key={`control--${index}`}
          >
            <Icon name={application} color={active ? "#47AE56" : "#404040"} />
            {/* <Icon name={application === 'chat' ? 'icon-message' : 'icon-document' } color='#262626' /> */}
          </div>
        );
      })}
    </div>
  );
};

const areEqual = (prevProps, nextProps) => {
  return prevProps.current === nextProps.current;
};

export default React.memo(Control, areEqual);
